export default __webpack_public_path__ + "static/media/arrowT.84b4b3b9.png";